import { CmsQuoteCentered } from './CmsQuoteCentered';
export { CmsQuoteCentered };
